import React from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
// import { Editor } from 'react-draft-wysiwyg';
import { InputProps } from '../../types/Common/input';
// import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import TimezoneSelect from 'react-timezone-select';
import './Styles.scss';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import CreatableSelect from 'react-select/creatable';
import ReactQuill from 'react-quill';
import JSONInput from 'react-json-editor-ajrm';
import { ReactMultiEmail } from 'react-multi-email';
import PhoneInput from 'react-phone-input-2';
import TimePicker from 'react-time-picker';
import TooltipButton from '../Crm/CommonTooltip';
import 'ckeditor5/ckeditor5.css';
import CKEditorComponent from './CKeditor';
import UiSchemaForm from './ArrayInput';
import { StatusClasses, StatusValues } from 'components/HeadlessCMS/Home/ContentManager';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.core.css';
const InputC: React.FC<InputProps> = ({
  label,
  type,
  placeholder,
  className,
  cols,
  rows,
  inputvalue,
  defaultValue,
  name,
  refrence,
  options,
  change,
  loadOptions,
  isEdit,
  size = 'lg',
  required = false,
  isMulti = true,
  disabled = false,
  isClearable = true,
  children,
  error,
  pattern,
  KeyPress,
  IsStar = true,
  defaultMenuIsOpen = false,
  maxDate = '',
  title = '',
  min = '',
  autoFocus,
  tooltip = null,
  isIcon = true,
  isCustum = false,
  onKeyUp,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const [value, setValue] = React.useState([]);
  const toggleDropdown1 = () => {
    setDropdownOpen(!dropdownOpen);
  };
  let sampleObject = { example: 'hello world' };
  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case 'Enter':
      case 'Tab':
        change((prev) => [...prev, createOption(inputValue)]);
        setInputValue('');
        event.preventDefault();
    }
  };
  const DropdownIndicator = React.memo(() => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', borderStyle: 'none' }}>
        <img
          style={{ paddingRight: '0.5rem', borderStyle: 'none' }}
          src="/manage/images/arrow.svg"
          alt="Dropdown Arrow"
        />
      </div>
    );
  });
  const customStyles = {
    indicatorsContainer: () => ({
      '.myDropDown': {
        '&__clear-indicator': {
          border: 'none', // <--- Color of your choice
        },
      },
    }),
  };
  const customStylesUi = {
    control: (provided, state) => ({
      ...provided,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: '#efefef',
      border: '1px solid #EDEDED',
      borderRadius: '40px',
      padding: '2px 16px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#1F2937',
      fontWeight: '500',
      fontSize: '14px',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#9CA3AF',
      ':hover': {
        backgroundColor: 'transparent',
        color: 'black',
        borderRadius: '4px',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9CA3AF',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  const CustomOption = (props) => {
    const { data, innerRef, innerProps, isSelected } = props;
    const style = StatusClasses[data.status];

    // Conditional style for selected option
    const selectedStyle = isSelected
      ? {
          background: '#9a6ecc',
          color: 'white',
          border: '1px solid #4a4a6a',
        }
      : {};
    return (
      <div
        ref={innerRef}
        {...innerProps}
        className="custom-option d-flex justify-content-between items-center px-3 py-2 hover:bg-gray-100 w-100"
        style={selectedStyle}
      >
        <span>{data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label}</span>{' '}
        <span
          className="text-xs font-semibold text-gray-500"
          style={{
            border: '1px solid #4a4a6a',
            padding: '4px 0.5rem',
            display: 'inline-block',
            height: 'min-content',
            fontWeight: 'bold',
            fontSize: '14px',
            borderRadius: '4px',
            background: style.bacground,
            color: style.text,
          }}
        >
          {StatusValues[data.status]}
        </span>
      </div>
    );
  };
  // Custom selected value for single-select
  const CustomSingleValue = ({ data, ...props }) => {
    const style = StatusClasses[data.status];

    return (
      <div className="custom-option d-flex justify-content-between items-center px-3 py-2 hover:bg-gray-100 w-100">
        <span>{data.label}</span>
        <span
          className="text-xs font-semibold text-gray-500"
          style={{
            border: '1px solid #4a4a6a',
            padding: '4px 0.5rem',
            fontWeight: 'bold',
            fontSize: '14px',
            borderRadius: '4px',
            background: style.bacground,
            color: style.text,
          }}
        >
          {StatusValues[data.status]}
        </span>
      </div>
    );
  };

  // Custom selected value for multi-select (each tag)
  const CustomMultiValueLabel = ({ data }) => {
    const style = StatusClasses[data.status];

    return (
      <div className="d-flex items-center gap-3 p-2">
        <span>{data.label.length > 20 ? data.label.slice(0, 20) + '...' : data.label}</span>{' '}
        <span
          className="text-xs font-semibold text-gray-500"
          style={{
            border: '1px solid #4a4a6a',
            padding: '1px 0.5rem',
            height: 'min-content',
            fontWeight: 'bold',
            fontSize: '14px',
            borderRadius: '4px',
            background: style?.bacground,
            color: style?.text,
          }}
        >
          {StatusValues[data.status]}
        </span>{' '}
      </div>
    );
  };

  return (
    <div className={`d-flex flex-column ${className}`}>
      {label && type !== 'Checkbox' && type !== 'Filter' && (
        <label
          className="custom-label"
          style={{ opacity: disabled ? '50%' : '100%', display: 'flex', alignItems: 'center' }}
        >
          {label}
          {required && IsStar ? <span className="red-color">*</span> : ''}{' '}
          {tooltip && (
            <TooltipButton
              MaxWidth={'20rem'}
              ContentText={tooltip}
              Position="bottom"
              Content={undefined}
            />
          )}
        </label>
      )}
      {(type === 'text' ||
        type === 'email' ||
        type === 'number' ||
        type === 'time' ||
        type === 'password' ||
        type === 'datetime-local' ||
        type === 'color' ||
        type === 'date') && (
        <input
          placeholder={placeholder}
          name={name}
          type={type}
          autoFocus={autoFocus}
          autoComplete="false"
          className={`${size}-input Custom-input`}
          onChange={change ? (e) => change(e) : undefined}
          value={inputvalue}
          defaultValue={defaultValue ? defaultValue : undefined}
          ref={refrence}
          pattern={pattern && pattern !== '' ? pattern : undefined}
          title={title}
          onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
          onKeyUp={onKeyUp ? (e) => onKeyUp(e) : undefined}
          disabled={disabled}
          required={required}
        />
      )}
      {type === 'range' && (
        <input
          placeholder={placeholder}
          name={name}
          type={type}
          autoComplete="false"
          className={`${size}-input Custom-input Custom-input-range`}
          onChange={change ? (e) => change(e) : undefined}
          value={inputvalue}
          defaultValue={defaultValue ? defaultValue : undefined}
          ref={refrence}
          min={min}
          max={maxDate}
          onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
          onKeyUp={onKeyUp ? (e) => onKeyUp(e) : undefined}
          disabled={disabled}
          required={required}
        />
      )}
      {type === 'radio' &&
        options.map((item, i) => (
          <div
            className={`${inputvalue === item.value ? 'Radio-button-Active' : ''} d-flex Radio-button`}
            style={{ cursor: 'pointer' }}
            key={i}
          >
            <input
              placeholder={placeholder}
              name={name}
              id={`${name}-${i}`} // Use unique ID for each input
              type="radio"
              className="w-25 Custom-input Radio-button"
              value={item.value}
              onClick={change ? (e) => change(e) : undefined}
              onChange={() => {}}
              checked={inputvalue === item.value}
              disabled={disabled}
              required={required}
            />
            <label htmlFor={`${name}-${i}`} style={{ cursor: 'pointer' }}>
              {item.label}
            </label>
          </div>
        ))}
      {/* {type === 'radio' &&
        options.map((item) => {
          return (
            <div className="d-flex Radio-button" key={item.id}>
              <input
                placeholder={placeholder}
                name={name}
                type="radio"
                className="Custom-input Radio-button"
                onChange={change ? (e) => change(e) : undefined}
                value={item.value}
                checked={inputvalue && inputvalue === item.value ? true : false}
                disabled={disabled}
                required={required}
              />
              <label>{item.label}</label>
            </div>
          );
        })} */}
      {type === 'Checkbox' && (
        <div className="d-flex align-items-center">
          <input
            type="checkbox"
            id="scales"
            className={`${size}-checkmark checkmark me-3`}
            name={name}
            onChange={change ? (e) => change(e) : undefined}
            value={inputvalue ? 1 : 0}
            checked={inputvalue}
            required={required}
            disabled={disabled}
          />
          <label className="custom-label mb-0">{label}</label>
        </div>
      )}

      {type === 'select' && (
        <Select
          components={{
            IndicatorSeparator: null,
            DropdownIndicator: DropdownIndicator,
          }}
          styles={customStylesUi}
          // classNamePrefix='myDropDown'
          defaultMenuIsOpen={defaultMenuIsOpen}
          className="Select-input"
          options={options}
          // menuIsOpen={true}
          value={
            isEdit
              ? inputvalue
              : (inputvalue && options?.find((option) => option?.value === inputvalue)) || undefined
          }
          name={name}
          isClearable={isClearable}
          placeholder={<div className="select-placeholder-text">{placeholder}</div>}
          isSearchable
          // menuIsOpen={true}
          defaultValue={
            defaultValue ? options.find((option) => option?.value === defaultValue) : undefined
          }
          onChange={change ? (e) => change(e) : undefined}
          required={required}
          isMulti={isEdit}
          isDisabled={disabled}
        />
      )}
      {type === 'Asyncselect' && (
        <AsyncSelect
          components={{
            // Custom control to open the dropdown on the entire area
            IndicatorSeparator: null,
            DropdownIndicator: () => {
              return (
                <>
                  <img style={{ paddingRight: '0.5rem' }} src="/manage/images/arrow.svg" />
                </>
              );
            },
            ...(isCustum && {
              Option: CustomOption, // inject the custom option here
              // SingleValue: CustomSingleValue,
              MultiValueLabel: CustomMultiValueLabel,
            }),
          }}
          cacheOptions={false}
          isMulti={isEdit ? false : true}
          defaultOptions
          value={inputvalue}
          loadOptions={loadOptions}
          placeholder={<div className="select-placeholder-text">{placeholder}</div>}
          required={required}
          isDisabled={disabled}
          isSearchable
          onChange={change ? (e) => change(e) : undefined}
          className="mb-4 regionSelect mb-md-3"
        />
      )}
      {type === 'TextArea' && (
        <textarea
          className="Custom-input "
          rows={rows}
          name={name}
          cols={cols}
          style={{
            resize: 'none',
          }}
          ref={refrence}
          defaultValue={defaultValue ? defaultValue : undefined}
          onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
          onKeyUp={onKeyUp ? (e) => onKeyUp(e) : undefined}
          onChange={change ? (e) => change(e) : undefined}
          placeholder={placeholder}
          required={required}
          value={inputvalue}
          disabled={disabled}
        ></textarea>
      )}
      {type === 'Editor' && (
        // <Editor
        //   editorState={inputvalue}
        //   toolbarClassName="toolbarClassName"
        //   wrapperClassName="wrapperClassName"
        //   editorClassName="editorClassName"
        //   onEditorStateChange={change}
        // />
        <></>
      )}
      {type === 'timeZone' && (
        <TimezoneSelect
          components={{
            // Custom control to open the dropdown on the entire area
            IndicatorSeparator: null,
            DropdownIndicator: () => {
              return (
                <>
                  <img style={{ paddingRight: '0.5rem' }} src="/manage/images/arrow.svg" />
                </>
              );
            },
          }}
          value={inputvalue}
          onChange={change ? (e) => change(e) : undefined}
          required={required}
          isDisabled={disabled}
          // required={row.required}
        />
      )}
      {type === 'togglemode' && (
        <label className="switch">
          <input
            type="checkbox"
            name={name}
            onChange={change ? (e) => change(e) : undefined}
            checked={inputvalue}
            required={required}
            disabled={disabled}
          />
          <span className="slider round"></span>
        </label>
      )}
      {type === 'Searchbar' && (
        <div className="d-flex search-box justify-content-between p-2">
          <div className="d-flex w-100">
            <img src="/manage/images/SVG/searchd.svg" alt="" />
            <input
              type="search"
              name={name}
              placeholder={placeholder}
              value={inputvalue}
              disabled={disabled}
              autoComplete="off"
              onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
              onChange={change ? (e) => change(e) : undefined}
            />
          </div>
          {isIcon && <img src="/manage/images/forward.svg" alt="" />}
        </div>
      )}
      {type === 'Filter' && (
        <>
          <Dropdown className={`dropdown-container`} isOpen={dropdownOpen} toggle={toggleDropdown1}>
            <DropdownToggle
              className={`dropdown-button noselect  ${
                inputvalue.length > 0 ? 'Filter-dropdown-select' : 'Filter-dropdown-noselect'
              }`}
            >
              <div className="Centertext">
                <h6 style={{ margin: '0' }}>{label}</h6>
                {inputvalue.length > 0 && <div className="countcircle">{inputvalue.length}</div>}
                <div>
                  {inputvalue.length > 0 ? (
                    <div
                      style={{
                        transform: `rotate(${dropdownOpen ? '270' : '0'}deg)`,
                        display: 'inline-block',
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <mask
                          id="mask0_4034_20536"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#929292" />
                        </mask>
                        <g mask="url(#mask0_4034_20536)">
                          <path
                            d="M11.3779 14.025L9.15288 11.775C8.86955 11.4917 8.80288 11.1667 8.95288 10.8C9.10288 10.4333 9.38622 10.25 9.80289 10.25H14.2279C14.6279 10.25 14.9069 10.4333 15.0649 10.8C15.2236 11.1667 15.1612 11.4917 14.8779 11.775L12.6529 14.025C12.5529 14.1083 12.4529 14.175 12.3529 14.225C12.2529 14.275 12.1362 14.3 12.0029 14.3C11.8862 14.3 11.7779 14.275 11.6779 14.225C11.5779 14.175 11.4779 14.1083 11.3779 14.025Z"
                            fill="#F6F6F6"
                          />
                        </g>
                      </svg>
                    </div>
                  ) : (
                    <div
                      style={{
                        transform: `rotate(${dropdownOpen ? '270' : '0'}deg)`,
                        display: 'inline-block',
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <mask
                          id="mask0_4034_20545"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect width="24" height="24" fill="#929292" />
                        </mask>
                        <g mask="url(#mask0_4034_20545)">
                          <path
                            d="M11.3779 14.025L9.15288 11.775C8.86955 11.4917 8.80288 11.1667 8.95288 10.8C9.10288 10.4333 9.38622 10.25 9.80289 10.25H14.2279C14.6279 10.25 14.9069 10.4333 15.0649 10.8C15.2236 11.1667 15.1612 11.4917 14.8779 11.775L12.6529 14.025C12.5529 14.1083 12.4529 14.175 12.3529 14.225C12.2529 14.275 12.1362 14.3 12.0029 14.3C11.8862 14.3 11.7779 14.275 11.6779 14.225C11.5779 14.175 11.4779 14.1083 11.3779 14.025Z"
                            fill="#1E293B"
                          />
                        </g>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            </DropdownToggle>
            <DropdownMenu className="dropdown-list" style={{ width: '360px' }}>
              <span className="Filetr-title"> Shower</span>

              {options.map((state) => (
                <DropdownItem
                  key={state.value}
                  className="d-flex justify-content-start align-items-center gap-1"
                  name={name}
                  onClick={() => change(state.value)}
                >
                  <input
                    type="checkbox"
                    className={`sm-checkmark checkmark me-3`}
                    checked={inputvalue.includes(state.value)}
                    readOnly
                  />
                  <span className="Filetr-options">{state.label}</span>
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </>
      )}
      {type === 'DatePicker' && (
        <DatePicker
          minDate={new Date()}
          maxDate={maxDate}
          disabled={disabled}
          dateFormat="dd/MM/yyyy"
          onChange={change ? (e) => change(e) : undefined}
          selected={inputvalue}
          className={`${size}-input Custom-input`}
        />
      )}
      {type === 'CreatableSelect' && (
        <CreatableSelect
          isClearable={isClearable}
          isMulti={isMulti}
          isDisabled={disabled}
          components={{
            // Custom control to open the dropdown on the entire area
            IndicatorSeparator: null,
            DropdownIndicator: () => {
              return (
                <>
                  <img style={{ paddingRight: '0.5rem' }} src="/manage/images/arrow.svg" />
                </>
              );
            },
          }}
          value={inputvalue ? inputvalue : undefined}
          // allowCreateWhileLoading={true}
          onChange={(newValue) => change(newValue)}
          // onInputChange={(newValue) => setInputValue(newValue)}
          onKeyDown={handleKeyDown}
          placeholder="Type something and press enter..."
        />
      )}

      {type === 'json' && (
        <>
          {/* <JSONInput
            id={getRandomID()}
            locale={locale}
            onChange={change ? (e) => change(e) : undefined}
            placeholder={inputvalue ? JSON.parse(inputvalue) : {}}
            width="100%"
            height="200px"
            colors={{
              background: '#ffff',
              number: '#000',
              keys: '#000',
              colon: '#000',
              keys_whiteSpace: '#000',
              primitive: '#000',
            }}
          /> */}
          <UiSchemaForm value={inputvalue} onChange={change} />
        </>
      )}

      {type === 'editor' && (
        <>
          <ReactQuill
            // style={{ height: '100px',marginBottom:"3rem" }}
            ref={(el) => {
              if (refrence) refrence.current = el; // store the ReactQuill instance
            }}
            onKeyDown={KeyPress ? (e) => KeyPress(e) : undefined}
            onKeyUp={onKeyUp ? (e) => onKeyUp(e) : undefined}
            theme="snow"
            value={inputvalue ? inputvalue : undefined}
            onChange={change ? (e) => change(e) : undefined}
          />
        </>
      )}
      {type === 'CMSeditor' && (
        <>
          <CKEditorComponent value={inputvalue} onChange={change} disabled={disabled} />
          {/* <div className="text-editor">
            <EditorToolbar />
            <ReactQuill
              // style={{ height: '100px',marginBottom:"3rem" }}
              theme="snow"
              // modules={modules}
              modules={modules}
              formats={formats}
              value={inputvalue ? inputvalue : undefined}
              onChange={change ? (e) => change(e) : undefined}
            />
          </div> */}
        </>
      )}
      {type === 'Phoneinput' && (
        <div className="phoneinput w-100">
          <PhoneInput
            inputStyle={{ width: '100%' }}
            containerClass="w-100"
            inputClass={`${size}-input Custom-input`}
            autoFormat={true}
            country={'in'}
            value={inputValue}
            onChange={change ? (e) => change(e) : undefined}
          />
        </div>
      )}
      {type === 'TimePicker' && (
        <TimePicker
          format="HH:mm:ss"
          onChange={change ? (e) => change(e) : undefined}
          value={inputvalue}
          className={`${size}-input Custom-input`}
        />
      )}
      {type === 'multiemail' && (
        <>
          {/* <ReactMultiEmail
            emails={inputvalue}
            onChange={change}
            autoFocus={true}
            getLabel={(email, index, removeEmail) => {
              return (
                <div data-tag key={index}>
                  <div data-tag-item>{email}</div>
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>
              );
            }}
          /> */}
          <div ref={refrence}>
            <ReactMultiEmail
              placeholder="Input your Email Address"
              emails={inputvalue}
              className={`Custom-class-email`}
              onChange={change}
              onKeyUp={onKeyUp ? (e) => onKeyUp(e) : undefined}
              allowDuplicate={false}
              getLabel={(email: string, index: number, removeEmail: (index: number) => void) => (
                <div data-tag key={index}>
                  {email}
                  <span data-tag-handle onClick={() => removeEmail(index)}>
                    ×
                  </span>
                </div>
              )}
            />
          </div>
        </>
      )}
      {error && <span style={{ color: 'red', fontSize: '14px' }}>{error}</span>}
      {type === 'Children' && <div>{children}</div>}
    </div>
  );
};

export default InputC;
const createOption = (label: string) => ({
  label,
  value: label,
});
